export default __webpack_public_path__ + "static/media/logo_picto.adc4bbb5.svg";